// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"5fadee70","125":"07dccce2","453":"7d34ab6f","479":"b809776c","858":"24390928"}[chunkId] + ".chunk.js";
};